var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5083 44.3613C28.7092 44.3613 30.4935 46.1456 30.4935 48.3465V65.4417C30.4935 67.6426 28.7092 69.4266 26.5083 69.4266C24.3077 69.4266 22.5234 67.6426 22.5234 65.4417V48.3465C22.5234 46.1458 24.3077 44.3616 26.5083 44.3616V44.3613Z",
    fill: "#A4C639"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4113 23.8086C17.3982 23.9597 17.3867 24.1125 17.3867 24.267V50.1678C17.3867 52.9533 19.5916 55.1973 22.3286 55.1973H48.668C51.4054 55.1973 53.6102 52.9531 53.6102 50.1678V24.267C53.6102 24.1125 53.6046 23.9591 53.5917 23.8086H17.4113Z",
    fill: "#A4C639"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4895 44.3606C46.6904 44.3606 48.4746 46.1448 48.4746 48.3458V65.441C48.4746 67.6419 46.6904 69.4259 44.4895 69.4259C42.2888 69.4259 40.5046 67.6419 40.5046 65.441V48.3458C40.5046 46.1451 42.2888 44.3609 44.4895 44.3609V44.3606ZM10.9852 26.1124C13.1858 26.1124 14.97 27.8967 14.97 30.0976V47.1928C14.97 49.3937 13.1858 51.178 10.9852 51.178C8.78424 51.178 7 49.3937 7 47.1931V30.0979C6.99972 27.8969 8.78396 26.1124 10.9852 26.1124ZM60.0151 26.1124C62.2158 26.1124 64 27.8967 64 30.0976V47.1928C64 49.3937 62.2158 51.178 60.0151 51.178C57.8142 51.178 56.03 49.3937 56.03 47.1931V30.0979C56.03 27.8969 57.8142 26.1124 60.0151 26.1124ZM17.5291 22.106C17.64 14.1502 24.5838 7.62724 33.4972 6.76758H37.5022C46.4162 7.62752 53.3595 14.1508 53.4703 22.106H17.5291Z",
    fill: "#A4C639"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9141 6L23.1178 13.2814M52.084 6L47.88 13.2814",
    stroke: "#A4C639",
    strokeWidth: 10.5192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1468 14.9773C30.1502 16.0894 29.2298 16.9935 28.0909 16.9966C26.9525 16.9994 26.0268 16.1006 26.0234 14.9885V14.9773C26.0204 13.865 26.9408 12.9611 28.0794 12.958C29.2178 12.9549 30.1435 13.8535 30.1468 14.9661V14.9773ZM45.5368 14.9773C45.5401 16.0894 44.6197 16.9935 43.4808 16.9966C42.3424 16.9994 41.4167 16.1006 41.4134 14.9885V14.9773C41.4103 13.865 42.3307 12.9611 43.4693 12.958C44.6077 12.9549 45.5334 13.8535 45.5368 14.9661V14.9773Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.9f3282903de220d77ba430bf4223c6b7.svg";
export { ForwardRef as ReactComponent };